import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { SettingsProvider } from "@/lib/settings";
import { ADMIN_BASE } from "@/lib/brand";
import PublicLayout from "@/components/PublicLayout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Spares from "@/pages/Spares";
import SpareDetail from "@/pages/SpareDetail";
import Services from "@/pages/Services";
import Engineers from "@/pages/Engineers";
import Gallery from "@/pages/Gallery";
import Events from "@/pages/Events";
import Media from "@/pages/Media";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Podcasts from "@/pages/Podcasts";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/components/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminSpares from "@/pages/admin/AdminSpares";
import AdminSpareOrders from "@/pages/admin/AdminSpareOrders";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminPodcasts from "@/pages/admin/AdminPodcasts";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminAnnouncement from "@/pages/admin/AdminAnnouncement";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminMenu from "@/pages/admin/AdminMenu";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminChatWidget from "@/pages/admin/AdminChatWidget";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Toaster position="top-right" richColors />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/spares" element={<Spares />} />
                <Route path="/spares/:slug" element={<SpareDetail />} />
                <Route path="/services" element={<Services />} />
                <Route path="/engineers" element={<Engineers />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/events" element={<Events />} />
                <Route path="/media" element={<Media />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/podcasts" element={<Podcasts />} />
                <Route path="/contact" element={<Contact />} />
              </Route>

              <Route path={`${ADMIN_BASE}/login`} element={<AdminLogin />} />
              <Route path={ADMIN_BASE} element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="spares" element={<AdminSpares />} />
                <Route path="spare-orders" element={<AdminSpareOrders />} />
                <Route path="blogs" element={<AdminBlogs />} />
                <Route path="podcasts" element={<AdminPodcasts />} />
                <Route path="events" element={<AdminEvents />} />
                <Route path="gallery" element={<AdminGallery />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="announcements" element={<AdminAnnouncement />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="menu" element={<AdminMenu />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="team" element={<AdminTeam />} />
                <Route path="chat-widget" element={<AdminChatWidget />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}
